import { ConferencePromo } from './ConferencePromo'
import Link from './Link'
import { GraphicsImage, LogoImage } from './ImageDetail'
import { ExpoVideoDetail, VideoDetail } from './VideoDetail'
import SocialAccount from './SocialAccount'
import ContentVisibility from './ContentVisibility'
import AttachmentDetail from './AttachmentDetail'
import CalendarModule from './CalendarModule'
import { ListModule } from './ListModule'
import RichTextModule from './RichTextModule'
import VideoModule from './VideoModule'
import Seo from './Seo'
import { ExhibitorCategories } from './ExhibitorCategories'

export const MinimumExhibitorDetail = `
  ${LogoImage}
  ${ContentVisibility}
  ${AttachmentDetail}
  fragment MinimumExhibitorDetail on ExhibitorDetail {
    contentLocale
    id
    name
    companyDescription
    companyWebsite {
      url
    }
    downloadableResources {
      ...AttachmentDetail
    }
    exhibitorAssociatedUsers
    url
    logo {
      ...LogoImage
    }
    sourceId
    sponsor
    sponsorLevel
    visibility {
      ...ContentVisibility
    }
  }
`

export const DashboardExhibitorDetail = `
  ${ConferencePromo}
  ${LogoImage}
  ${ContentVisibility}
  ${AttachmentDetail}
  ${ExhibitorCategories}
  fragment DashboardExhibitorDetail on ExhibitorDetail {
    companyDescription
    companyWebsite {
      url
    }
    contentLocale
    downloadableResources {
      ...AttachmentDetail
    }
    exhibitorAssociatedUsers
    exhibitorCategories {
      ...ExhibitorCategories
    }
    highResolutionLogo {
      ...AttachmentDetail
    }
    id
    logo {
      ...LogoImage
    }
    name
    promotions {
      ...ConferencePromo
    }
    sourceId
    sponsor
    sponsorLevel
    url
    visibility {
      ...ContentVisibility
    }
    whiteOnTransparentLogo {
      ...AttachmentDetail
    }
  }
`

export const ExhibitorDetail = `
  ${ConferencePromo}
  ${Link}
  ${ExpoVideoDetail}
  ${LogoImage}
  ${GraphicsImage}
  ${VideoDetail}
  ${SocialAccount}
  ${ContentVisibility}
  ${CalendarModule}
  ${ListModule}
  ${RichTextModule}
  ${VideoModule}
  ${AttachmentDetail}
  ${Seo}
  ${ExhibitorCategories}
  fragment ExhibitorDetail on ExhibitorDetail {
    additionalExperiences {
      ...ConferencePromo
    }
    alternateLocales
    companyContactEmail
    companyContactUsPage {
      ...Link
    }
    companyDescription
    companyFaqs {
      ...Link
    }
    companySupportPage {
      ...Link
    }
    companyWebsite {
      ...Link
    }
    content {
      ...CalendarModule
      ...ConferencePromo
      ...ListModule
      ...RichTextModule
      ...VideoModule
    }
    contentLocale
    downloadableResources {
      ...AttachmentDetail
    }
    exhibitorCategories {
      ...ExhibitorCategories
    }
    graphics {
      ...GraphicsImage
    }
    highResolutionLogo {
      ...AttachmentDetail
    }
    id
    logo {
      ...LogoImage
    }
    name
    promotions {
      ...ConferencePromo
    }
    seo {
      ...Seo
    }
    socialAccounts {
      ...SocialAccount
    }
    sponsor
    sponsorLevel
    supportingChat
    url
    visibility {
      ...ContentVisibility
    }
    welcomeVideo {
      ...ExpoVideoDetail
    }
    whiteOnTransparentLogo {
      ...AttachmentDetail
    }
  }
`
